import * as React from "react";
import PropTypes from "prop-types";
import CircleCheckIcon from "./icons/core/circle-check";
import ArrowRightIcon from "./icons/core/arrow-right";
import LinkIcon from "./icons/core/link";
import PespiIcon from "./icons/brands/pepsi";
import CocaColaIcon from "./icons/brands/coca-cola";
import HelloFreshIcon from "./icons/brands/hello-fresh";
import AllCladIcon from "./icons/brands/all-clad";
import HersheyIcon from "./icons/brands/hershey";
import UnileverIcon from "./icons/brands/unilever";
import KonaBrewingIcon from "./icons/brands/kona-brewing";
import MichelinIcon from "./icons/brands/michelin";
import AbbottIcon from "./icons/brands/abbott";
import AllerganIcon from "./icons/brands/allergan";
import BallIcon from "./icons/brands/ball";
import BaxterIcon from "./icons/brands/baxter";
import BayerGlobalIcon from "./icons/brands/bayer-global";
import BemisIcon from "./icons/brands/bemis";
import BendixIcon from "./icons/brands/bendix";
import BerryIcon from "./icons/brands/berry";
import BoschIcon from "./icons/brands/bosch";
import BremoIcon from "./icons/brands/brembo";
import BristolMyersSquibbIcon from "./icons/brands/bristol-myers-squibb";
import DensoIcon from "./icons/brands/denso";
import GeneralMotorsIcon from "./icons/brands/general-motors";
import GoodYearIcon from "./icons/brands/good-year";
import HospiraIcon from "./icons/brands/hospira";
import MahleIcon from "./icons/brands/mahle";
import McNeilinIcon from "./icons/brands/mcneil";
import MercedesBenzIcon from "./icons/brands/mercedes-benz";
import MerckIcon from "./icons/brands/merck";
import MitsubaIcon from "./icons/brands/mitsuba";
import PacktivIcon from "./icons/brands/packtiv";
import PerrigoIcon from "./icons/brands/perrigo";
import PfizerIcon from "./icons/brands/pfizer";
import ReckittIcon from "./icons/brands/reckitt";
import RockTennIcon from "./icons/brands/rock-tenn";
import SigNodeIcon from "./icons/brands/sig-node";
import SmurFitIcon from "./icons/brands/smurfit";
import SonocoIcon from "./icons/brands/sonoco";
import TennecoIcon from "./icons/brands/tenneco";
import TetraPackIcon from "./icons/brands/tetra-pak";
import VisualPackIcon from "./icons/brands/visual-pak";
import AcerosLealIcon from "./icons/brands/aceros-leal";
import AjaxIcon from "./icons/brands/ajax";
import AmnealIcon from "./icons/brands/amneal";
import AryztaIcon from "./icons/brands/aryzta";
import CaliforniaOliveRanchIcon from "./icons/brands/california-olive-ranch";
import CatalentIcon from "./icons/brands/catalent";
import GroteIcon from "./icons/brands/grote";
import GSKIcon from "./icons/brands/gsk";
import HaynesIcon from "./icons/brands/haynes";
import JBSIcon from "./icons/brands/jbs";
import KerryIcon from "./icons/brands/kerry";
import LandOLakesIcon from "./icons/brands/land-o-lakes";
import LuvataIcon from "./icons/brands/luvata";
import MauserPackagingIcon from "./icons/brands/mauser-packaging-solutions";
import MaximaRacingOilIcon from "./icons/brands/maxima-racing-oil";
import ModelezIcon from "./icons/brands/modelez";
import MolsonCoorsIcon from "./icons/brands/molson-coors";
import NorthernStampingIcon from "./icons/brands/northern-stamping";
import NovolexIcon from "./icons/brands/novolex";
import OhioMetalIcon from "./icons/brands/ohio-metal";
import OlympicSteelIcon from "./icons/brands/olympic-steel";
import PrattIndustriesIcon from "./icons/brands/pratt-industries";
import SpecialMetalsIcon from "./icons/brands/special-metals";
import TakedaIcon from "./icons/brands/takeda";
import TekniplexIcon from "./icons/brands/tekniplex";
import UnitedGearIcon from "./icons/brands/united-gear";
import WaelzholzIcon from "./icons/brands/waelzholz";
import WestRockIcon from "./icons/brands/westrock";
import WielandIcon from "./icons/brands/wieland";
import ZoetisIcon from "./icons/brands/zoetis";
import TIFluidSystemsIcon from "./icons/brands/ti-fluid-systems";
import AmericanAxleManufacturingIcon from "./icons/brands/american-axle-manufacturing";
import BellsBreweryIcon from "./icons/brands/bells-brewery";
import BlueWaterProductsIcon from "./icons/brands/blue-water-products";
import KanpackIcon from "./icons/brands/kanpak";
import KorbelChampagneCellarsIcon from "./icons/brands/korbel-champagne-cellars";
import MizkanAmericaIcon from "./icons/brands/mizkan-america";
import PhoenixBevIcon from "./icons/brands/phoenix-bev";
import SaputoIcon from "./icons/brands/saputo";
import SunnySkyProductsIcon from "./icons/brands/sunny-sky-products";
import AmcorIcon from "./icons/brands/amcor";
import BimboIcon from "./icons/brands/bimbo";
import CrownHoldingIcon from "./icons/brands/crown-holdings";
import GraphicPackagingIcon from "./icons/brands/graphic-packaging";
import ProampacIcon from "./icons/brands/proampac";

import TheEsteeLauderCompaniesIcon from "./icons/brands/the-estee-lauder-companies";
import WeckerleCosmeticsIcon from "./icons/brands/weckerle-cosmetics";
import KdcOneIcon from "./icons/brands/kdc-one";
import BAndRProductsIcon from "./icons/brands/b&r-products";
import OxygenDevelopmentIcon from "./icons/brands/oxygen-development";
import VoyantIcon from "./icons/brands/voyant";
import CosmeticaLaboratorieIcon from "./icons/brands/cosmetica-laboratorie";
import DmiPersonalCareIcon from "./icons/brands/dmi-personal-care";
import RevlonIcon from "./icons/brands/revlon";
import MineralsTechnologiesIcon from "./icons/brands/minerals-technologies";
import YorkWallcoversIcon from "./icons/brands/york-wallcovers";
import RpiPrintIcon from "./icons/brands/rpi-print";
import OlympakIcon from "./icons/brands/olympak";
import MeyersIcon from "./icons/brands/meyers";
import InnovativeLabelingSolutionsIcon from "./icons/brands/innovative-labeling-solutions";
import HammerPackagingIcon from "./icons/brands/hammer-packing";
import FrankstonPackagingIcon from "./icons/brands/frankston-packaging";
import BestDealGraphicsIcon from "./icons/brands/best-deal-graphics";
import ArmorIimakIcon from "./icons/brands/armor-iimak";
import StrykerIcon from "./icons/brands/stryker";
import SterisIcon from "./icons/brands/steris";
import RocheIcon from "./icons/brands/roche";
import MedlineIcon from "./icons/brands/medline";
import EdwardsLifeSciencesIcon from "./icons/brands/edwards-lifesciences";
import BostonScientificIcon from "./icons/brands/boston-scientific";
import BectonDickinsonIcon from "./icons/brands/becton-dickinson";
import BBraunMedicalIcon from "./icons/brands/b-braun-medical";
import AdvancedSterilizationProductsIcon from "./icons/brands/advanced-sterilization-products";
import SaintGobainIcon from "./icons/brands/saint-gobain";
import QuickreteIcon from "./icons/brands/quickrete";
import JeldWenIcon from "./icons/brands/jeld-wen";
import CertainteedIcon from "./icons/brands/certainteed";
import OwensCorningIcon from "./icons/brands/owens-corning";
import NovatechIcon from "./icons/brands/novatech";
import MasterBuildersIcon from "./icons/brands/master-builders";
import MasoniteIcon from "./icons/brands/masonite";
import CemexIcon from "./icons/brands/cemex";
import CabinetworksGroupIcon from "./icons/brands/cabinetworks-group";
import BoiseCascadeIcon from "./icons/brands/boise-cascade";
import AssaAbloyIcon from "./icons/brands/assa-abloy";
import SugarBowlBakeryIcon from "./icons/brands/sugar-bowl-bakery";
import SaraLeeIcon from "./icons/brands/sara-lee";
import RiseBakingIcon from "./icons/brands/rise-baking";
import HighlandBakingIcon from "./icons/brands/highland-baking";
import GiveAndGoIcon from "./icons/brands/give-and-go";
import CHGuentherAndSonIcon from "./icons/brands/c-h-guenther-and-son";
import AuntMilliesIcon from "./icons/brands/aunt-millies";
import AspireBakeriesIcon from "./icons/brands/aspire-bakeries";
import AlphaBakingIcon from "./icons/brands/alpha-baking";

import AtkoreIcon from "./icons/brands/atkore";
import BondexIcon from "./icons/brands/bondex";
import CtiPaperUsaIcon from "./icons/brands/cti-paper-usa";
import DeltaPaperCorpIcon from "./icons/brands/delta-paper-corp";
import EnersysIcon from "./icons/brands/enersys";
import ExideGroupIcon from "./icons/brands/exide-group";
import GhMetalIcon from "./icons/brands/gh-metal";
import HoneywellIcon from "./icons/brands/honeywell";
import JabilIcon from "./icons/brands/jabil";
import KeecoIcon from "./icons/brands/keeco";

import LittleRapidsCorpIcon from "./icons/brands/little-rapids-corp";
import LumiteIcon from "./icons/brands/lumite";
import MacPapersAndPackagingIcon from "./icons/brands/mac-papers-and-packaging";
import MajorMetalsIcon from "./icons/brands/major-metals";
import MmericanWoodFibersIcon from "./icons/brands/mmerican-wood-fibers";
import MorbernIcon from "./icons/brands/morbern";
import NewMatherMetalsIcon from "./icons/brands/new-mather-metals";
import NidecMotorCorpIcon from "./icons/brands/nidec-motor-corp";
import NutexIcon from "./icons/brands/nutex";
import NventIcon from "./icons/brands/nvent";

import OhioMulchIcon from "./icons/brands/ohio-mulch";
import OxIndustriesIcon from "./icons/brands/ox-industries";
import RegalRexnordIcon from "./icons/brands/regal-rexnord";
import RexelUsaIcon from "./icons/brands/rexel-usa";
import SeamanPaperIcon from "./icons/brands/seaman-paper";
import SuperiorLinenServiceIcon from "./icons/brands/superior-linen-service";
import TeConnectivityIcon from "./icons/brands/te-connectivity";
import UtahPaperworkIcon from "./icons/brands/utah-paperwork";
import VarbrosIcon from "./icons/brands/varbros";
import WebindustriesIcon from "./icons/brands/webindustries";
import BlueGrassLivingIcon from "./icons/brands/blue-grass-living";

const vorneIconMap = new Map([
  ["american-axle-manufacturing", AmericanAxleManufacturingIcon],
  ["aceros-leal", AcerosLealIcon],
  ["ajax", AjaxIcon],
  ["amneal", AmnealIcon],
  ["aryzta", AryztaIcon],
  ["california-olive-ranch", CaliforniaOliveRanchIcon],
  ["catalent", CatalentIcon],
  ["grote", GroteIcon],
  ["gsk", GSKIcon],
  ["haynes", HaynesIcon],
  ["jbs", JBSIcon],
  ["kerry", KerryIcon],
  ["land-o-lakes", LandOLakesIcon],
  ["luvata", LuvataIcon],
  ["mauser-packaging-solutions", MauserPackagingIcon],
  ["maxima-racing-oil", MaximaRacingOilIcon],
  ["modelez", ModelezIcon],
  ["molson-coors", MolsonCoorsIcon],
  ["northern-stamping", NorthernStampingIcon],
  ["novolex", NovolexIcon],
  ["ohio-metal", OhioMetalIcon],
  ["olympic-steel", OlympicSteelIcon],
  ["pratt-industries", PrattIndustriesIcon],
  ["special-metals", SpecialMetalsIcon],
  ["takeda", TakedaIcon],
  ["tekniplex", TekniplexIcon],
  ["ti-fluid-systems", TIFluidSystemsIcon],
  ["united-gear", UnitedGearIcon],
  ["waelzholz", WaelzholzIcon],
  ["westrock", WestRockIcon],
  ["wieland", WielandIcon],
  ["zoetis", ZoetisIcon],
  ["circle-check", CircleCheckIcon],
  ["link", LinkIcon],
  ["arrow-right", ArrowRightIcon],
  ["pepsi", PespiIcon],
  ["coca-cola", CocaColaIcon],
  ["hello-fresh", HelloFreshIcon],
  ["all-clad", AllCladIcon],
  ["hershey", HersheyIcon],
  ["unilever", UnileverIcon],
  ["kona-brewing", KonaBrewingIcon],
  ["michelin", MichelinIcon],
  ["abbott", AbbottIcon],
  ["allergan", AllerganIcon],
  ["ball", BallIcon],
  ["baxter", BaxterIcon],
  ["bayer-global", BayerGlobalIcon],
  ["bemis", BemisIcon],
  ["bendix", BendixIcon],
  ["berry", BerryIcon],
  ["bosch", BoschIcon],
  ["brembo", BremoIcon],
  ["bristol-myer-squibb", BristolMyersSquibbIcon],
  ["denso", DensoIcon],
  ["general-motors", GeneralMotorsIcon],
  ["good-year", GoodYearIcon],
  ["hospira", HospiraIcon],
  ["mahle", MahleIcon],
  ["mcneil", McNeilinIcon],
  ["mercedes-benz", MercedesBenzIcon],
  ["merck", MerckIcon],
  ["mitsuba", MitsubaIcon],
  ["packtiv", PacktivIcon],
  ["perrigo", PerrigoIcon],
  ["pfizer", PfizerIcon],
  ["reckitt", ReckittIcon],
  ["rock-tenn", RockTennIcon],
  ["sig-node", SigNodeIcon],
  ["smurfit", SmurFitIcon],
  ["sonoco", SonocoIcon],
  ["tenneco", TennecoIcon],
  ["tetra-pak", TetraPackIcon],
  ["visual-pak", VisualPackIcon],
  ["bells-brewery", BellsBreweryIcon],
  ["blue-water-products", BlueWaterProductsIcon],
  ["kanpak", KanpackIcon],
  ["korbel-champagne-cellars", KorbelChampagneCellarsIcon],
  ["mizkan-america", MizkanAmericaIcon],
  ["phoenix-bev", PhoenixBevIcon],
  ["saputo", SaputoIcon],
  ["sunny-sky-products", SunnySkyProductsIcon],
  ["amcor", AmcorIcon],
  ["bimbo", BimboIcon],
  ["crown-holdings", CrownHoldingIcon],
  ["graphic-packaging", GraphicPackagingIcon],
  ["proampac", ProampacIcon],
  ["the-estee-lauder-companies", TheEsteeLauderCompaniesIcon],
  ["weckerle-cosmetics", WeckerleCosmeticsIcon],
  ["kdc-one", KdcOneIcon],
  ["b&r-products", BAndRProductsIcon],
  ["oxygen-development", OxygenDevelopmentIcon],
  ["voyant", VoyantIcon],
  ["cosmetica-laboratorie", CosmeticaLaboratorieIcon],
  ["dmi-personal-care", DmiPersonalCareIcon],
  ["revlon", RevlonIcon],
  ["minerals-technologies", MineralsTechnologiesIcon],
  ["york-wallcovers", YorkWallcoversIcon],
  ["rpi-print", RpiPrintIcon],
  ["olympak", OlympakIcon],
  ["meyers", MeyersIcon],
  ["innovative-labeling-solutions", InnovativeLabelingSolutionsIcon],
  ["hammer-packaging", HammerPackagingIcon],
  ["frankston-packaging", FrankstonPackagingIcon],
  ["best-deal-graphics", BestDealGraphicsIcon],
  ["armor-iimak", ArmorIimakIcon],
  ["stryker", StrykerIcon],
  ["steris", SterisIcon],
  ["roche", RocheIcon],
  ["medline", MedlineIcon],
  ["edwards-lifesciences", EdwardsLifeSciencesIcon],
  ["boston-scientific", BostonScientificIcon],
  ["becton-dickinson", BectonDickinsonIcon],
  ["b-braun-medical", BBraunMedicalIcon],
  ["advanced-sterilization-products", AdvancedSterilizationProductsIcon],
  ["saint-gobain", SaintGobainIcon],
  ["quickrete", QuickreteIcon],
  ["jeld-wen", JeldWenIcon],
  ["certainteed", CertainteedIcon],
  ["owens-corning", OwensCorningIcon],
  ["novatech", NovatechIcon],
  ["master-builders", MasterBuildersIcon],
  ["masonite", MasoniteIcon],
  ["cemex", CemexIcon],
  ["cabinetworks-group", CabinetworksGroupIcon],
  ["boise-cascade", BoiseCascadeIcon],
  ["assa-abloy", AssaAbloyIcon],
  ["sugar-bowl-bakery", SugarBowlBakeryIcon],
  ["sara-lee", SaraLeeIcon],
  ["rise-baking", RiseBakingIcon],
  ["highland-baking", HighlandBakingIcon],
  ["give-and-go", GiveAndGoIcon],
  ["c-h-guenther-and-son", CHGuentherAndSonIcon],
  ["aunt-millies", AuntMilliesIcon],
  ["aspire-bakeries", AspireBakeriesIcon],
  ["alpha-baking", AlphaBakingIcon],
  ["atkore", AtkoreIcon],
  ["bondex", BondexIcon],
  ["cti-paper-usa", CtiPaperUsaIcon],
  ["delta-paper-corp", DeltaPaperCorpIcon],
  ["enersys", EnersysIcon],
  ["exide-group", ExideGroupIcon],
  ["gh-metal", GhMetalIcon],
  ["honeywell", HoneywellIcon],
  ["jabil", JabilIcon],
  ["keeco", KeecoIcon],
  ["little-rapids-corp", LittleRapidsCorpIcon],
  ["lumite", LumiteIcon],
  ["mac-papers-and-packaging", MacPapersAndPackagingIcon],
  ["major-metals", MajorMetalsIcon],
  ["american-wood-fibers", MmericanWoodFibersIcon],
  ["morbern", MorbernIcon],
  ["new-mather-metals", NewMatherMetalsIcon],
  ["nidec-motor-corp", NidecMotorCorpIcon],
  ["nutex", NutexIcon],
  ["nvent", NventIcon],
  ["ohio-mulch", OhioMulchIcon],
  ["ox-industries", OxIndustriesIcon],
  ["regal-rexnord", RegalRexnordIcon],
  ["rexel-usa", RexelUsaIcon],
  ["seaman-paper", SeamanPaperIcon],
  ["superior-linen-service", SuperiorLinenServiceIcon],
  ["te-connectivity", TeConnectivityIcon],
  ["utah-paperwork", UtahPaperworkIcon],
  ["varbros", VarbrosIcon],
  ["webindustries", WebindustriesIcon],
  ["blue-grass-living", BlueGrassLivingIcon],
]);

function renderVorneIcon(props) {
  const { className, height, width, name, style } = props;
  const IconComponent = vorneIconMap.get(name);
  return (
    <IconComponent
      className={className}
      height={height}
      width={width}
      color={style?.color}
    />
  );
}

function Icon(props) {
  const { className, height, width, name, style } = props;
  return renderVorneIcon({ className, height, width, name, style });
}

Icon.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(["vorne"]).isRequired,
  name: PropTypes.string,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  style: PropTypes.shape({
    color: PropTypes.string,
  }),
};

export default Icon;
